import { IResort } from '@entities/resort/@/hotel';
import { ICountry } from '@entities/country/@/hotel';
import { ChildServiceId } from './IChildService';
import { RestTypeId } from './RestType';
import { BeachTypeId } from './IBeachType';

import { ICoordinates } from './ICoordinates';
import { IDistances } from './IDistances';

export enum RenovationType {
    RecentlyOpened = 'recently_opened',
    FreshRenovation = 'fresh_renovation',
}

export interface IHotel {
    id: number;
    resort: IResort | null;
    country: ICountry | null;
    attributes: number[]
    beachLine: number | null;
    coords: ICoordinates;
    distances: IDistances;
    hotelCategory: number;
    name: string;
    ordersNumber: number;
    placement: null;
    rating: number;
    reviewsNumber: number;
    renovationDate: null | number;
    builtDate: null | number;
    beachType: BeachTypeId | 0,
    renovationType: RenovationType | null;
    types: number[]
    childServices: ChildServiceId[];
    restTypes: RestTypeId[];
}
